/* global Office, Excel, document, HTMLButtonElement, HTMLParagraphElement, HTMLTextAreaElement, HTMLElement */
import "./taskpane.css";
import { CellmateDemandForecast } from "@cellmate-tpa-osdk/sdk";
import {
  ensureSignedIn,
  getClient,
  resetClient,
  setAuthProgress,
  setAuthRequestUrl,
} from "../auth/getClient";
import { clearTokens } from "../auth/tokenStore";

Office.onReady(() => {
  const button = document.getElementById("import") as HTMLButtonElement;
  const signOutBtn = document.getElementById("signout") as HTMLButtonElement;
  const status = document.getElementById("status") as HTMLParagraphElement;

  const pasteForm = document.getElementById("paste-form") as HTMLElement;
  const pasteInput = document.getElementById("paste-input") as HTMLTextAreaElement;
  const pasteSubmit = document.getElementById("paste-submit") as HTMLButtonElement;
  const pasteCancel = document.getElementById("paste-cancel") as HTMLButtonElement;

  const setStatus = (msg: string) => {
    status.textContent = msg;
  };
  setAuthProgress(setStatus);

  // Show the paste form, resolve when the user submits the URL.
  setAuthRequestUrl(
    () =>
      new Promise<string>((resolve, reject) => {
        pasteForm.hidden = false;
        pasteInput.value = "";
        pasteInput.focus();

        const cleanup = () => {
          pasteForm.hidden = true;
          pasteInput.value = "";
          pasteSubmit.onclick = null;
          pasteCancel.onclick = null;
        };

        pasteSubmit.onclick = () => {
          const url = pasteInput.value.trim();
          if (!url) return;
          cleanup();
          resolve(url);
        };

        pasteCancel.onclick = () => {
          cleanup();
          reject(new Error("Sign-in cancelled"));
        };
      })
  );

  signOutBtn.onclick = async () => {
    await clearTokens();
    resetClient();
    setStatus("Signed out. Next Import will require sign-in.");
  };

  button.onclick = async () => {
    button.disabled = true;
    setStatus("Preparing…");
    try {
      // Sign in (if needed) BEFORE creating/using the OSDK client. Having
      // the OSDK await on a long user-interactive OAuth flow inside its auth
      // callback caused the subsequent fetch to hang silently in WKWebView.
      await ensureSignedIn();

      const client = getClient();

      setStatus("Calling Foundry…");
      const all: Record<string, unknown>[] = [];
      let token: string | undefined;
      let pageNum = 0;
      do {
        pageNum++;
        setStatus(`Fetching page ${pageNum} (${all.length} rows so far)…`);
        const page = await client(CellmateDemandForecast).fetchPage({
          $pageSize: 100,
          ...(token && { $nextPageToken: token }),
        });
        all.push(...(page.data as unknown as Record<string, unknown>[]));
        token = page.nextPageToken;
      } while (token);

      if (all.length === 0) {
        setStatus("No data returned.");
        return;
      }

      setStatus(`Writing ${all.length} rows to sheet…`);
      await Excel.run(async (ctx) => {
        const sheet = ctx.workbook.worksheets.getActiveWorksheet();
        const headers = Object.keys(all[0]);
        const rows = all.map((r) => headers.map((h) => r[h] ?? ""));
        const range = sheet.getRange("A1").getResizedRange(rows.length, headers.length - 1);
        range.values = [headers, ...rows];
        sheet.getUsedRange().format.autofitColumns();
        await ctx.sync();
      });

      setStatus(`Wrote ${all.length} rows.`);
    } catch (err) {
      setStatus(`Error: ${err instanceof Error ? err.message : String(err)}`);
    } finally {
      button.disabled = false;
    }
  };
});
